import React from 'react';
import { graphql } from 'gatsby';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import Layout from '../../components/Layout';
import PageHeader from '../../components/PageHeader';
import ModularBlocks from '../../components/ModularBlocks';
import { getSchemaDescription, getServiceSchemaData } from '../../utils';

const PlantsForBusinessDefaultPageTemplate = ({
  data: {
    datoCmsPlantsForBusinessPage: {
      seoMetaTags,
      title,
      modularBlocks,
      serviceSchema,
    },
    datoCmsPlantsForBusiness: { sitewideNotices },
  },
}) => {
  const serviceData = getServiceSchemaData({
    serviceSchema,
    seoMetaTags,
    title,
  });

  return (
    <Layout
      title={title}
      description={getSchemaDescription(seoMetaTags)}
      service={serviceData}
      sitewideNotices={sitewideNotices}
    >
      <HelmetDatoCms seo={seoMetaTags} />
      <main>
        <PageHeader
          heading={title}
          breadcrumbs={[
            { slug: 'plants-for-business', text: 'Plants for Business' },
          ]}
        />
        <ModularBlocks items={modularBlocks} />
      </main>
    </Layout>
  );
};

export const PlantsForBusinessDefaultPageTemplateQuery = graphql`
  query PlantsForBusinessDefaultPageTemplateQuery($id: String!) {
    datoCmsPlantsForBusinessPage(id: { eq: $id }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      modularBlocks {
        ...AccordionModularBlockFragment
        ...CompanyReviewsModularBlockFragment
        ...ContactFormModularBlockFragment
        ...ContainedImageModularBlockFragment
        ...ContentModularBlockFragment
        ...ExternalVideoModularBlockFragment
        ...FeaturedLogosModularBlockFragment
        ...FeaturedProjectsModularBlockFragment
        ...FullWidthImageModularBlockFragment
        ...HighlightedTextModularBlockFragment
        ...IconCtasModularBlockFragment
        ...ImageContentModularBlockFragment
        ...ImageGalleryModularBlockFragment
        ...ImageLinkCardsModularBlockFragment
        ...InternalVideoModularBlockFragment
        ...TabsModularBlockFragment
        ...TeamProfilesModularBlockFragment
        ...TestimonialsModularBlockFragment
      }
      serviceSchema {
        serviceType
        serviceAreaServed
      }
    }
    datoCmsPlantsForBusiness {
      sitewideNotices {
        text
      }
    }
  }
`;

export default PlantsForBusinessDefaultPageTemplate;
